import React from 'react';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import {dateDiff} from '../utils/dateUtil';

dayjs.locale('zh-cn');

const List = (props) => {
  const statusIcon = {
    1: 'live-advance-835.png',
    2: '2025071/live-ing-2025071.png',
    3: 'live-end-835.png',
    4: 'live-playback-835.png'
  }

  return Array.isArray(props.list) &&
    props.list.map((item) => {
      // 1电报 2深度文章 3稿库 4商讯 5直播
      const isShort = [1, 3, '1', '3'].includes(item.belong);
      const isLive = [5, '5'].includes(item.belong);

      let createTime = '';
      if (!!item.create_time) {
        createTime = dateDiff(item.create_time * 1000);
      }
      return (
        <div key={item.tid} className="d-f b-c-1e252be8e8f3 topic-dynamic-item">
          <a className="d-f w-100p" href={`${isShort ? '/te/' : isLive ? '/li/' : '/de/'}${item.tid}`}>
            {
              Array.isArray(item.img_list) && !!item.img_list.length && !isShort &&
              <div className="f-s-0 p-r o-h topic-dynamic-item-img-box">
                <img alt="" src={item.img_list[0]} className="w-100p h-100p topic-dynamic-item-img"/>
                {
                  isLive && props.type === 'topic' && 
                  <div className={`p-a t-0 l-0 p-r-6 p-l-6 f-s-12 f-w-b c-fff ${item.permission === 3 ? 'bg-c-cb8839-f0d5af' : 'bg-c-339aff-84bfff'} article-live-tag`}>
                    {item.permission === 2 ? '邀约' : item.permission === 1 ? '免费' : item.permission === 3 ? '付费' : ''}
                  </div>
                }
              </div>
            }
            {
              props.type === 'person' && !!item.cover_img &&
              <div className="f-s-0 o-h topic-dynamic-item-img-box">
                <img alt="" src={item.cover_img} className="w-100p h-100p topic-dynamic-item-img"/>
              </div>
            }
            <div className="f-g-1 d-f f-d-c f-b-s w-100p topic-dynamic-item-content">
              <div className="f-s-16 f-w-n-b c-ffffff191c27 l-h-125 t-o-e l-c-2 o-h topic-dynamic-item-content-desc">{!isShort ? (item.title || item.content || '') : (item.title ? `【${item.title}】${item.content}` : item.content)}</div>
              {
                Array.isArray(item.img_list) && !!item.img_list.length && isShort &&
                (
                  item.img_list.length === 1 ?
                    <div className="w-100p o-h">
                      <img alt="" src={item.img_list[0]} className="topic-dynamic-item-telegraph-img1"/>
                    </div> :
                    <div className="w-100p o-h">
                      {
                        item.img_list.map(itemImage => <img key={itemImage} alt="" src={itemImage} className="topic-dynamic-item-telegraph-img2"/>)
                      }
                    </div>
                )
              }
              {
                !isLive ? 
                <div className="w-100p d-f f-b-c f-s-13 c-6465669395a2 l-h-125 topic-dynamic-item-content-action">
                  <div className="o-h l-c-1 t-o-e w-b-a topic-dynamic-item-from">{item.from_source} {createTime}</div>
                  <div className="o-h l-c-1 t-o-e topic-dynamic-item-num">{item.view_num} 阅读</div>
                </div> :
                (statusIcon[item.status] && 
                  <div className="w-100p d-f f-s-c topic-dynamic-item-content-action">
                    <div className={`f-s-0 p-r d-f f-c-c m-r-5 ${item.status === 2 ? 'w-53' : 'w-48'}`}>
                      <img className="w-100p h-100p o-f-c" src={`https://file.jingpt.com/wap/images/${statusIcon[item.status]}`} alt="" />
                      {
                        item.status === 2 &&
                        <>
                        <div className="p-a t-50p w-2 h-10 bg-c-ff0027 t-o-c-b article-live-animation-1"></div>
                        <div className="p-a t-50p w-2 h-10 bg-c-ff0027 t-o-c-b article-live-animation-2"></div>
                        <div className="p-a t-50p w-2 h-10 bg-c-ff0027 t-o-c-b article-live-animation-3"></div>
                        </>
                      }
                    </div>
                    <div className="f-g-1 w-s-n o-h f-s-12 l-h-133333 c-9ea5bb">
                      {dayjs(item.start_time * 1000).format('YYYY-MM-DD HH:mm')}
                      {item.end_time &&
                      dayjs(item.start_time * 1000).format('YYYY-MM-DD') === dayjs(item.end_time * 1000).format('YYYY-MM-DD')
                        ? `-${dayjs(item.end_time * 1000).format('HH:mm')}`
                        : ''}
                    </div>
                  </div>
                )
              }
            </div>
          </a>
        </div>
      )
    })
};

export default List;